import { useIntl } from "react-intl";

const AtlassianGuardStandard = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "JiraSoftwarePricingPageTeam24.features.atlassianGuardStandard.title",
            defaultMessage:
                "Atlassian Guard Standard (SSO, SCIM, Active Directory Sync)"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPageTeam24.features.atlassianGuardStandard.body",
            defaultMessage:
                "Enforced single sign-on, external user security, mobile app management, org insights, admin-initiated audit logs."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default AtlassianGuardStandard;
